import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class DashboardPagePath extends BasePagePath {
  public static path(): string {
    return 'dashboard';
  }
}
